// 判断图谱渲染是否完成
export function waitForGraphRenderCompletion(containerId, callback, timeout = 5000) {
  const container = document.getElementById(containerId);
  if (!container) return;
  let lastHeight = -1;
  let lastWidth = -1;
  let stableCount = 0;
  const maxStableFrames = 5;
  const checkSize = () => {
    const { height, width } = container.getBoundingClientRect();
    if (height === lastHeight && width === lastWidth) {
      stableCount++;
      if (stableCount >= maxStableFrames) {
        clearTimeout(timeoutId);
        callback();
        return;
      }
    } else {
      stableCount = 0;
    }
    lastHeight = height;
    lastWidth = width;
    requestAnimationFrame(checkSize);
  };
  const timeoutId = setTimeout(() => {
    console.warn('图谱渲染超时，强制认为已完成');
    callback();
  }, timeout);
  checkSize();
}
